import axios from './axiosInstance';

export default {
  // Create a new log (communication)
  createLog(logData) {
    return axios.post('/logs/', logData);
  },
  // Get logs for a project with pagination
  getLogsByProjectId(projectId, order = 'desc', page = 1, size = 10) {
    return axios.get(`/logs/projects/${projectId}`, {
      params: { order, page, size },
    });
  },

  getThreadsByProjectId(projectId, type = 'all', order = 'desc', page = 1, size = 10) {
    return axios.get(`/logs/projects/${projectId}/threads`, {
      params: { order, page, size, comm_type: type },
    });
  },
  // Search logs within a project
  searchLogs(projectId, query, type = 'all', page = 1, size = 10) {
    return axios.get(`/logs/projects/search/${projectId}`, {
      params: { query, page, size, comm_type: type },
    });
  },
  searchThreads(projectId, query, type = 'all', page = 1, size = 10) {
    return axios.get(`/logs/threads/search/${projectId}`, {
      params: { query, page, size, comm_type: type },
    });
  },
  // Get projects with new unseen logs
  getProjectsWithNewActivity() {
    return axios.get('/logs/activity/total_new');
  },
  // Delete a single email communication
  deleteEmailLog(communicationId) {
    return axios.delete(`/logs/emails/${communicationId}`);
  },
  // Delete an email thread
  deleteEmailThread(threadId) {
    return axios.delete(`/logs/emails/threads/${threadId}`);
  },
  // Delete a single text communication
  deleteTextLog(communicationId) {
    return axios.delete(`/logs/sms/${communicationId}`);
  },
  // Delete a text thread
  deleteTextThread(threadId) {
    return axios.delete(`/logs/sms/threads/${threadId}`);
  },
  getMessagesByThreadId(threadId, order = 'asc', page = 1, size = 10) {
    return axios.get(`/logs/threads/${threadId}/messages`, {
      params: { order, page, size },
    });
  },
  getMailsByThreadId(threadId, order = 'asc', page = 1, size = 10) {
    return axios.get(`/logs/threads/${threadId}`, {
      params: { order, page, size },
    });
  },
  sendTextMessage(formData) {
    return axios.post("/sms/send", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },
  getNewLogsByProjectId(projectId) {
    return axios.get(`/logs/activity/new/${projectId}`);
  },
  findTextThread(projectId, stakeholders) {
    return axios.post(`/logs/sms/find_thread`, { project_id: projectId, participant_phone_numbers: stakeholders });
  },
};
